import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';
import { FINGERPRINT_PATHS } from './identity.utils';

@Component({
  selector: 'app-vehicle-fingerprint-identity',
  templateUrl: './identity.component.html',
  styleUrls: ['./identity.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintIdentityComponent {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  readonly fingerprintPaths = FINGERPRINT_PATHS;
}
